import { IPublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { ConfigProvider } from "antd";
import "./App.css";
import { AuthenticationProvider } from "./auth/AuthenticationProvider";
import WebDRouter from "./WebDRouter";
import { BrowserRouter } from "react-router-dom";

type TAppProps = {
  readonly instance: IPublicClientApplication;
};
function App({ instance }: TAppProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "DM Sans",
          colorPrimary: "#1868db",
          colorText: "#121212",
        },
        components: {
          Table: {
            borderRadius: 12,
            headerBorderRadius: 12,
            borderColor: "#77777733"
          }
        }
      }}>
      <MsalProvider instance={instance}>
        <BrowserRouter>
          <AuthenticationProvider>
            <WebDRouter />
          </AuthenticationProvider>
        </BrowserRouter>
      </MsalProvider>
    </ConfigProvider>
  );
}

export default App;
